import { useQuery } from "@tanstack/react-query";
import Logger from "../utils/logger";

const useGetApi = (apiDefinition: {
  queryKey: any[];
  queryFn: () => Promise<any>;
}) => {
  const queries = {
    queryKey: apiDefinition.queryKey,
    queryFn: apiDefinition.queryFn,
  };
  const { data, isLoading, isPending, isError, error, refetch } =
    useQuery(queries);

  if (isError && error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    const isNetworkError =
      errorMessage.toLowerCase().includes("failed to fetch") ||
      errorMessage.toLowerCase().includes("network") ||
      !navigator.onLine;

    if (isNetworkError) {
      Logger.warn("Network Error:", {
        queryKey: apiDefinition.queryKey,
        error: "Network connectivity issue",
        online: navigator.onLine,
      });
    } else {
      Logger.error("API Error:", {
        queryKey: apiDefinition.queryKey,
        error: errorMessage,
      });
    }
  }

  return {
    data: data?.data ?? [],
    isLoading,
    isPending,
    isError,
    error,
    refetch,
  };
};

export default useGetApi;
